import {
  FETCH_STUDENT_ENQUIRY_PENDING,
  FETCH_STUDENT_ENQUIRY_SUCCESS,
  FETCH_STUDENT_ENQUIRY_ERROR
} from "../action/studentEnquiryAction";

const initialState = {
  pending: false,
  studentEnquiry: [],
  error: null
};

const studentEnquiryReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STUDENT_ENQUIRY_PENDING:
      return {
        ...state,
        pending: true
      };
    case FETCH_STUDENT_ENQUIRY_SUCCESS:
      return {
        ...state,
        pending: false,
        studentEnquiry: action.payload
      };
    case FETCH_STUDENT_ENQUIRY_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error
      };
    default:
      return state;
  }
};
export default studentEnquiryReducer;
export const getStudentEnquiry = state => state.studentEnquiry;
export const getStudentEnquiryPending = state => state.pending;
export const getStudentEnquiryError = state => state.error;
